"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asPercentage = void 0;
var _number = require("../type-checks/number");
var asPercentage = exports.asPercentage = function asPercentage(input) {
  var divisor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  var returnValue = input;
  if ((0, _number.isNumber)(returnValue)) {
    returnValue = (returnValue / divisor).toString();
    var formatter = new window.Intl.NumberFormat("en-US", {
      style: "percent",
      minimumFractionDigits: precision
    });
    returnValue = formatter.format(returnValue);
  }
  return returnValue;
};